<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card
      color="success"
      icon="mdi-clipboard-text"
      inline
      title="Datos de mascostas"
      class="px-5 py-3 mb-5"
    >
    rol: {{ roltexto }}
      <v-data-table
        :headers="headers"
        :items="mascotas"
        sort-by="calories"
        class="elevation-1"
        fixed-header
        height="600px"
        :loading="loadingTable"
        loading-text="Cargando... Por favor esperar"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Mascotas</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="listarMascotasTipos()"
                >
                  Nueva Mascota
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5 text-bold">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <validation-observer v-slot="{ handleSubmit }">
                      <form @submit.prevent="handleSubmit(validateForm)">
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field
                                v-model="nombre"
                                label="Nombre *"
                                required
                                :rules="TextRules"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                v-model="tipo"
                                :items="mascotasTipos"
                                item-text="tipo"
                                item-value="unico"
                                label="Especie *"
                                dense
                                filled
                                return-object
                                v-on:change="listarMascotasSubTipos()"
                                required
                                :rules="TextRules"
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                v-model="raza"
                                :items="mascotasSubTipos"
                                item-text="sub_tipo"
                                item-value="unico"
                                label="Raza *"
                                dense
                                filled
                                return-object
                                required
                                :rules="TextRules"
                              >
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-menu
                                v-model="menu3"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="fecha_nacimiento"
                                    label="Seleccione Fecha de Nacimiento"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="fecha_nacimiento"
                                  @input="menu3 = false"
                                  v-on:change="CalcularEdad()"
                                  :max="minimo"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                filled
                                readonly
                                v-model="edad"
                                label="Edad"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                v-model="peso"
                                label="Peso Kg"
                                type="number"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <v-select
                                v-model="sexo"
                                label="Sexo *"
                                :items="sexoList"
                                required
                                filled
                                dense
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                v-model="color"
                                label="Color"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                v-model="chip"
                                label="#Chip"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-switch
                                v-model="castrado"
                                inset
                                color="red"
                                label="Castrado"
                              >
                              </v-switch>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" v-if="castrado">
                              <v-menu
                                v-model="menu4"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="fecha_castrado"
                                    label="Seleccione Fecha de Castración"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="fecha_castrado"
                                  @input="menu4 = false"
                                  :max="minimo"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-alert dense type="info">
                            Si no recuerdas ingresa fechas aproximadas
                          </v-alert>
                        </v-form>
                      </form>
                    </validation-observer>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" @click="close"> Cerrar </v-btn>
                  <v-btn color="primary" @click="guardar()" :disabled="!valid">
                    GUardar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5"
                  >Estas seguro de eliminar datos de su mascota?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" large @click="editarMAscota(item)">
                <v-icon dense color="error">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar datos de mascota</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" large @click="deleteItem(item)">
                <v-icon dense color="primary">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar mascota</span>
          </v-tooltip>

      
          <v-tooltip top  v-if="esAdmin">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" large @click="AtencionPresencial(item)">
                <v-icon dense color="info">mdi-calendar</v-icon>
              </v-btn>
            </template>
            <span>Generar atención médica presencial</span>
          </v-tooltip>
          <v-tooltip top  v-if="!esAdmin">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" large @click="Atencion(item)">
                <v-icon dense color="accent">mdi-calendar</v-icon>
              </v-btn>
            </template>
            <span>Generar atención médica</span>
          </v-tooltip>
        </template>
        <template v-slot:item.castrado="{ item }">
          <v-simple-checkbox
            v-model="item.castrado"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize"> Recargar </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <v-dialog
      v-model="dialogAtencion"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogAtencion = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >Atención médica para: {{ nombre_mascota }}
          </v-toolbar-title>
          <v-divider class="mx-4" vertical></v-divider>
          <span class="subheading">
        <!-- # Atención Médica: {{ numero_examen }}--></span 
          >
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <atencion-medica-online-component :component_mascota_uq="unico_mascota" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary" text @click="dialogAtencion = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogAtencionPresencial"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogAtencionPresencial = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >Atención médica para: {{ nombre_mascota }}
          </v-toolbar-title>
          <v-divider class="mx-4" vertical></v-divider>
          <span class="subheading">
        <!-- # Atención Médica: {{ numero_examen }}--></span 
          >
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <AtencionMedicaPresencialComponent :component_mascota_uq="unico_mascota" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="secondary" text @click="dialogAtencion = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import axios from "axios";
import AtencionMedicaOnlineComponent from "./AtencionMedicaOnlineComponent.vue";
import AtencionMedicaPresencialComponent from "./AtencionMedicaPresencialComponent.vue";

export default {
  name: "MascotaComponent",
  components: {
    AtencionMedicaOnlineComponent,
    AtencionMedicaPresencialComponent,
  },
  data: () => ({
    roltexto:"",
    esAdmin:false,
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Tipo", value: "tipo" },
      { text: "Raza", value: "raza" },
      { text: "Edad", value: "edad" },
      { text: "Peso", value: "peso" },
      { text: "Sexo", value: "sexo" },
      { text: "Castrado", value: "castrado" },
      { text: "#Chip", value: "chip" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    mascotas: [],
    editedIndex: -1,
    nombre: "",
    tipo: "",
    raza: "",
    edad: "",
    peso: 0,
    sexo: "",
    castrado: false,
    chip: "",
    color: "",
    unico_mascota: "",
    dialogAtencion: false,
    dialogAtencionPresencial: false,
    veterinario_mascota_uq: "",
    examen_medico_uq: "",
    nombre_mascota: "",
    mascotasTipos: [],
    mascota_tipo_uq: "",
    mascotasSubTipos: [],
    loader: null,
    loading: false,
    minimo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    sexoList: ["Macho", "Hembra"],
    valid: true,
    snackbar: false,
    text: "",
    timeout: 6000,
    menu3: false,
    fecha_nacimiento: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10),
    menu4: false,
    fecha_castrado: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10),
    TextRules: [(v) => !!v || "campo requerida"],
    loadingTable: false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Mascota" : "Editar Mascota";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
    component_usuario_uq: function (nuevoValor) {
      console.log("El valor del padre ha cambiado a:", nuevoValor);
      this.component_usuario_uq = nuevoValor;
      this.listar();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      console.log("Ingrese componente");
      this.listar();
      this.rol();
    },
    validate() {
      this.$refs.form.validate();
    },
    CalcularEdad() {
      let me = this;
      // Si la fecha es correcta, calculamos la edad
      var fecha = me.fecha_nacimiento;
      var values = fecha.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];
      // cogemos los valores actuales
      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      // realizamos el calculo
      var edad = ahora_ano + 1900 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }
      // calculamos los meses
      var meses = 0;
      if (ahora_mes > mes && dia > ahora_dia) meses = ahora_mes - mes - 1;
      else if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes && dia < ahora_dia) meses = 12 - (mes - ahora_mes);
      else if (ahora_mes < mes) meses = 12 - (mes - ahora_mes + 1);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;
      // calculamos los dias
      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }
      me.edad = edad + " años, " + meses + " meses y " + dias + " días";
    },
    rol(){
      let me=this;
      me.roltexto = localStorage.getItem("rol");
      console.log("entre rol ");
     // console.log(me.rolTexto);

      if( me.roltexto == "admin"){
        me.esAdmin=true;
      }else{
        me.esAdmin=false;
      }
      
    },
    listar() {
      let me = this;
      me.loadingTable = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/mascotas/ListarPorUsuario/" + me.component_usuario_uq, //localStorage.getItem("unico"),
          configuracion
        )
        .then(function (response) {
          me.mascotas = response.data;
          //change to string bool value
          me.loadingTable = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    Limpiar() {
      let me = this;
      me.nombre = "";
      me.tipo = "";
      me.raza = "";
      me.fecha_nacimiento = me.minimo;
      me.fecha_castrado= me.minimo;
      me.sexo = "";
      me.color = "";
      me.castrado = false;
      me.chip = "";
      me.peso = 0;
      me.edad="";
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //edit
        console.log("Actualizar " + me.unico);
        axios
          .put(
            "api/mascotas/Actualizar",
            {
              unico: me.unico,
              nombre: me.nombre,
              tipo: me.tipo.tipo,
              raza: me.raza.sub_tipo,
              fecha_nacimiento: me.fecha_nacimiento,
              edad: me.sexo,
              color: me.color,
              castrado: me.castrado,
              chip: me.chip,
              peso: me.peso,
            },
            configuracion
          )
          .then(function (response) {
            me.listar();
            console.log(response);
            me.Limpiar();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              this.$store.dispatch("salir");
            }
          });
      } else {
        console.log("crear usuario");
        if (me.nombre != "") {
          axios
            .post(
              "api/mascotas/Crear",
              {
                usuario_uq: me.component_usuario_uq, //localStorage.getItem("unico"),
                nombre: me.nombre,
                tipo: me.tipo.tipo,
                raza: me.raza.sub_tipo,
                fecha_nacimiento: me.fecha_nacimiento,
                edad: me.edad,
                color: me.color,
                castrado: me.castrado,
                chip: me.chip,
                sexo: me.sexo,
                castrado_fecha: me.fecha_castrado,
                peso: me.peso,
              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              console.log(response);
              me.Limpiar();
            })
            .catch((err) => {
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        }
      }
      this.close();
    },
    editItem(item) {
      //this.editedIndex = this.desserts.indexOf(item);
      //this.editedItem = Object.assign({}, item);
      console.log(item);
      this.dialog = true;
    },
    deleteItem(item) {
      let me = this;
      //this.editedIndex = this.desserts.indexOf(item);
      //this.editedItem = Object.assign({}, item);
      //console.log(item);
      me.unico_mascota = item.unico;
      me.dialogDelete = true;
    },
    deleteItemConfirm() {
      let me = this;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .delete("api/mascotas/" + me.unico_mascota, configuracion)
        .then(function () {
          me.listar();
          me.dialogDelete = false;
          me.text = "Se elimino la mascotas exitosamente";
          me.snackbar = true;
          //change to string bool value
        })
        .catch((err) => {
          console.log("errores catch");
          console.log(err);
          me.text =
            "No se puede eliminar mascota, existen atenciones asociadas";
          me.snackbar = true;
          me.dialogDelete = false;
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    Atencion(item) {
      let me = this;
      console.log("ENtre abrir popup");
      console.log(item);
      me.dialogAtencion = true;
      me.unico_mascota = item.unico;
      me.nombre_mascota = item.nombre;
    },
    AtencionPresencial(item) {
      let me = this;
      console.log("ENtre abrir popup");
      console.log(item);
      me.dialogAtencionPresencial = true;
      me.unico_mascota = item.unico;
      me.nombre_mascota = item.nombre;
    },
    GuardarPaso1() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      //crear la relacion Veterinario mascotas con el veterinario que no tiene asignacion
      // to do validar que solo exista un registro con el proceso== Abierto

      axios
        .post(
          "api/VeterinariosMascotas/Crear",
          {
            mascota_uq: me.unico_mascota,
          },
          configuracion
        )
        .then(function (response) {
          console.log("VeterinariosMascotas/Crear");

          console.log(response.data);
          console.log(response.data.unico);
          me.GuardarPaso1Sintoms(response.data.unico);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    GuardarPaso1Sintoms(veterinario_mascota_uq) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      //crear la relacion Veterinario mascotas con el veterinario que no tiene asignacion

      axios
        .post(
          "/api/ExamenesMedicos/Crear",
          {
            veterinario_mascota_uq: veterinario_mascota_uq,
            sintomas: me.sintoma,
          },
          configuracion
        )
        .then(function (response) {
          console.log(response);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarMascotasTipos() {
      let me = this;
      console.log("entre mascotas tipos");
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("/api/MascotasTipos/Listar", configuracion)
        .then(function (response) {
          me.mascotasTipos = response.data;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
        );
    },
    listarMascotasSubTipos() {
      let me = this;
      console.log("entre mascotas SUb tipos tipos: " + me.tipo.unico);
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.mascotasSubTipos = [];
      axios
        .get("/api/MascotasSubTipos/Lista/" + me.tipo.unico, configuracion)
        .then(function (response) {
          me.mascotasSubTipos = response.data;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }}
        );
    },
  },
  props: {
    component_usuario_uq: String,
  },
};
</script>
  

